import ApiRequest from "@/helpers/ApiRequest";
import { SAVE_DATA_SETTINGS, SAVE_REALM_SETTINGS } from "@/store/mutation-types";
import GetHeaders from "../../helpers/GetHeaders";

export default {
  actions: {
    saveDataSettings: async ({ commit }, payload) => {
      return ApiRequest.explorePost(
        "globalsettings",
        {
          settings: payload
        },
        GetHeaders.dataHeaders()
      ).then(res => {
        commit(SAVE_DATA_SETTINGS, { data: res.data });
        return res;
      });
    },
    saveUserSettings: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "usersettings",
        {
          settings: payload
        },
        GetHeaders.dataHeaders()
      ).then(res => {
        dispatch("loadDataSettings");
        //commit(SAVE_DATA_SETTINGS, { data: res.data });
        return res;
      });
    },
    loadDataSettings: async ({ commit }) => {
      return ApiRequest.exploreGet("settings", GetHeaders.dataHeaders()).then(
        res => {
          if(res.data.focus && res.data.focus.layout && res.data.focus.layout.length && res.data.focus.layout[1].length){
            //console.log("Old Settings", JSON.parse(JSON.stringify(res.data)));
            let settings = JSON.parse(JSON.stringify(res.data));
            settings.focus.layout[0] = [];
            settings.focus.layout[1] = [];
            settings.focus.layout[2] = res.data.focus.layout[1];
            settings.focus.layout[3] = res.data.focus.layout[2];
            settings.focus.layout[4] = res.data.focus.layout[3];
            //console.log("New Setttings", settings);
            commit(SAVE_DATA_SETTINGS, { data: settings });
          }
          else{
            commit(SAVE_DATA_SETTINGS, { data: res.data });
          }
          return res.data;
        }
      );
    },
    saveRealmSettings: async ({ dispatch }, payload) => {
      return ApiRequest.explorePut("realm_settings", payload, GetHeaders.dataHeaders()).then(
        res => {
          dispatch("loadRealmSettings");
          return res.data;
        }
      );
    },
    loadRealmSettings: async ({ commit }) => {
      return ApiRequest.exploreGet("realm_settings", GetHeaders.dataHeaders()).then(
        res => {
          commit(SAVE_REALM_SETTINGS, { data: res.data });
          return res.data;
        }
      );
    },
  },
  getters: {
    modelTopic: (state) => state.dataSettings? state.dataSettings.filters.topic : ""
  },
  mutations: {
    [SAVE_DATA_SETTINGS](state, payload) {
      if(!payload.data.focus){
        state.dataSettings = payload.data;
      }
      else if(!payload.data.focus.lastQuery || payload.data.focus.lastQuery === null){
        state.dataSettings = payload.data;
        state.dataSettings.focus.lastQuery = [];
      } 
      else if(payload.data.focus.lastQuery.length > 0){
        if(typeof payload.data.focus.lastQuery[0] === 'object'){
          state.dataSettings = payload.data;
          state.dataSettings.focus.lastQuery = [];
        }
        else{
          state.dataSettings = payload.data;
        }
      }
      else{
        state.dataSettings = payload.data;
      }
    },
    [SAVE_REALM_SETTINGS](state, payload) {
      state.realmSettings = payload.data;
    }
  },
  state: {
    dataSettings: null,
    realmSettings: null
  }
};
